import {ExportColumnFormatter} from '../factory.export.column.fomatter';

export class FrequencySupportFormatter implements ExportColumnFormatter {
  format(row: any): any {
    const lines = [];

    for (const energy of row?.energy) {
      let line = '[';

      line += `${energy.freqMin.toFixed(2)}..${energy.freqMax.toFixed(2)}GHz,`;
      line += `${energy.resMax.toFixed(2)}kHz,`;
      line += `${energy.sens10.toFixed(2)}mJy/beam@10km/s,`;
      line += `${energy.sensBand.toFixed(2)}uJy/beam@native,`;
      line += `${energy.polProduct},`;
      line += `${energy.chaNum < 129 ? 'continuum' : 'line'}`;

      line += ']';

      lines.push(line);
    }
    return lines.join(' U ');
  }
}
